<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('user.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('user.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="d-flex justify-content-start">
            <ts-button color="info" outline @click="$router.push({ name: 'user-create' })"
              v-if="user_type == 'staff-api'">{{ $t('add_new') }}</ts-button>
          </div>
          <div class="ts-flex-grow"></div>
          <div class="ts-flex justify-content-center">
            <div class="btn-group btn-group-justified">
              <a class="btn btn-default" :class="office_staff" @click.prevent="officeStaff"
                v-if="$store.getters.authPermissionAllow('view-staff-users')">
                {{ $t('user.officeStaff') }}
              </a>
              <a class="btn btn-default" :class="teacher" @click.prevent="teachers"
                v-if="$store.getters.authPermissionAllow('view-teacher-users')">
                {{ $t('user.teacher') }}
              </a>
              <a class="btn btn-default" :class="parent" @click.prevent="parents"
                v-if="$store.getters.authPermissionAllow('view-parent-users')">
                {{ $t('user.parent') }}
              </a>
              <a class="btn btn-default" :class="student" @click.prevent="students"
                v-if="$store.getters.authPermissionAllow('view-student-users')">
                {{ $t('user.student') }}
              </a>
            </div>
          </div>
          <div class="ts-flex-grow"></div>
          <div class="ts-flex justify-content-end ts-space-x-2 ts-items-center">
            <a-radio-group class="ts-flex" v-model="disable">
              <a-radio-button :value="0">{{
                $t('user.active')
                }}</a-radio-button>
              <a-radio-button :value="1">{{
                $t('user.disabled')
                }}</a-radio-button>
            </a-radio-group>
            <ts-input v-model="search" :placeholder="$t('search')" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td class="text-center">{{ index + 1 }}</td>
          <td class="text-center with-img">
            <img class="height-30 ts-rounded" :class="{
              'allow-switch-external-mode':
                record.is_allow_switch_external_mode
            }" v-lazy="{
              src: getPhoto(record),
              error: onError(),
              loading: require('@/assets/Rolling-1s-200px_2.svg')
            }" />
          </td>
          <td>{{ record.loginname }}</td>
          <td>
            {{
              record.activated_type_id == 6
                ? record.employee
                  ? record.employee.name_en
                  : ''
                : record.full_name
            }}
          </td>
          <td>
            <table class="table-status" v-if="!isTeacherEmpty(record.teacher)">
              <tr>
                <td>
                  <a-popover :title="$t('user.className')" trigger="hover">
                    <template slot="content">
                      <div class="scroll">
                        <a-collapse accordion>
                          <a-collapse-panel v-for="(items, statusId) in groupByStatus(record.teacher.ac_classes)"
                            :key="statusId" :header="`(${items.length}) ${statusText(statusId)}`">
                            <ul>
                              <li v-for="(item, i) in items" :key="i" class="ts-px-4">
                                - {{ item.class_name }}
                              </li>
                            </ul>
                          </a-collapse-panel>
                        </a-collapse>

                      </div>
                    </template>
                    <span
                      class="ts-bg-gray-200 ts-text-gray-800 ts-text-xs ts-font-medium ts-me-2 ts-px-4 ts-py-0.5 ts-rounded-full ts-dark:bg-gray-700 ts-dark:text-gray-300"
                      v-if="
                        getClassCounts(record.teacher.ac_classes).length !== 0
                      ">
                      {{ getClassCounts(record.teacher.ac_classes).length }}
                    </span>
                  </a-popover>
                </td>
              </tr>
            </table>
          </td>
          <td>
            <span class="badge badge-primary mr-2" v-for="(role, index) in record.roles">{{ role.name }}</span>
          </td>
          <td class="text-center">
            <a-popconfirm placement="leftTop" :title="$t('user.are_you_sure_to_update')" :ok-text="$t('yes')"
              :cancel-text="$t('no')" @cancel="record.disable = !record.disable" @confirm="onUpdate(record)">
              <a-switch :loading="waiting" v-model="record.disable" size="small" />
            </a-popconfirm>
          </td>
          <td class="text-center">
            <a href="#" class="mr-2 text-info" @click.prevent="showModal(record)">
              <i class="fa fa-lock"></i>
            </a>
            <a v-if="user_type == 'staff-api'" href="#" class="mr-2 text-primary" @click.prevent="onEdit(record)">
              <i class="fa fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
        @close="() => (visible = false)" :zIndex="1020" width="300px">
        <div style="font-size: 12px">
          <div class="row">
            <div class="form-group">
              <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                  " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
      <a-modal v-model="visible_resetpwd" :title="$t('user.resetPassword')" @ok="handleOk" @cancel="closeModal"
        width="20%" :okText="$t('save')" :confirmLoading="waiting" :cancelText="$t('cancel')" :maskClosable="false">
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('user.password') }}</label>
            <input v-model="model.new_password" type="password" class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }" />
            <div class="invalid-feedback" v-if="errors.has('new_password')">
              {{ errors.first('new_password') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('user.confirm') }}</label>
            <input v-model="model.confirm_password" type="password" class="form-control"
              :class="{ 'is-invalid': errors.has('confirm_password') }" />
            <div class="invalid-feedback" v-if="errors.has('confirm_password')">
              {{ errors.first('confirm_password') }}
            </div>
          </div>
        </div>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce, groupBy, head, includes, isEmpty } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'userIndex',
  data() {
    return {
      visible_resetpwd: false,
      visible: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      office_staff: 'active',
      teacher: '',
      parent: '',
      student: '',
      branchs: [],
      tabPermissions: [
        'view-staff-users',
        'view-teacher-users',
        'view-parent-users',
        'view-student-users'
      ],
      model: {
        user_id: 0,
        new_password: null,
        confirm_password: null
      },
      defaultPhoto: require('@/assets/user_default.png')
    }
  },
  computed: {
    ...mapState('user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.user.search
      },
      set(newValue) {
        this.$store.commit('user/SET_SEARCH', newValue)
        this.$store.commit('user/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.user.branch_id
      },
      set(newValue) {
        this.$store.commit('user/SET_BRANCH_ID', newValue)
      }
    },
    user_type: {
      get() {
        return this.$store.state.user.user_type
      },
      set(val) {
        this.$store.commit('user/SET_USER_TYPE', val)
      }
    },
    disable: {
      get() {
        return this.$store.state.user.disable
      },
      set(val) {
        this.$store.commit('user/SET_DISABLED', val)
      }
    },
    columns() {
      return [
        {
          name: this.$t('user.numberic'),
          style: 'width:3%; text-align:center'
        },
        { name: this.$t('user.photo'), style: 'width:5%' },
        { name: this.$t('user.userName') },
        { name: this.$t('user.fullName') },
        { name: this.$t('user.numberOfClass') },
        { name: this.$t('user.roleName') },
        { name: this.$t('user.disable'), style: 'width:3%' },
        { name: this.$t('actions'), style: 'width:7%; text-align:center' }
      ]
    },
    statusText: () => statusId => {
      const statusMap = {
        1: 'Current',
        2: 'History',
        3: 'Next'
      }
      return statusMap[statusId] || ''
    },
    groupByStatus: () => acClass => {
      return groupBy(acClass, 'ac_status_id');
    }
  },
  created() {
    this.branch_id = this.$store.state.authUser
      ? [this.$store.state.authUser.default_branch_id]
      : []
    this.checkPermissionTab()
    this.getBranch()
  },
  methods: {
    checkPermissionTab() {
      let permissions = this.$store.state.authUser
        ? this.$store.state.authUser.permissions
        : null
      if (permissions) {
        let tab_permissions = this.tabPermissions.filter(tp_name =>
          includes(permissions.map(permission => permission), tp_name)
        )
        switch (head(tab_permissions)) {
          case 'view-staff-users':
            return this.officeStaff()

          case 'view-teacher-users':
            return this.teachers()

          case 'view-parent-users':
            return this.parents()

          case 'view-student-users':
            return this.students()

          default:
            return this.officeStaff()
        }
      }
    },
    getPhoto(record) {
      if (record.employee) {
        if (record.employee.photo) {
          return record.employee.photo
        }
      }
      return this.defaultPhoto
    },
    officeStaff() {
      this.user_type = 'staff-api'
      this.office_staff = 'active'
      this.teacher = ''
      this.parent = ''
      this.student = ''
    },
    teachers() {
      this.user_type = 'teacher-api'
      this.teacher = 'active'
      this.office_staff = ''
      this.parent = ''
      this.student = ''
    },
    parents() {
      this.user_type = 'parent-api'
      this.parent = 'active'
      this.office_staff = ''
      this.teacher = ''
      this.student = ''
    },
    students() {
      this.user_type = 'student-api'
      this.student = 'active'
      this.office_staff = ''
      this.teacher = ''
      this.parent = ''
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'user/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    async onUpdate(record) {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('user/changeDisable', {
          id: record.user_id,
          data: { disable: record.disable }
        })
        .then(async response => {
          this.$toasted.error(response.message)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchData()
          this.waiting = false
        })
    },
    onEdit(record) {
      this.$store.commit('user/SET_EDIT_DATA', record)
      this.$router.push({ name: 'user-edit', params: { id: record.user_id } })
    },
    onError() {
      event ? (event.target.src = this.defaultPhoto) : null
    },
    showModal(record) {
      this.model.user_id = record.user_id
      this.visible_resetpwd = true
    },
    closeModal() {
      this.model.user_id = 0
      this.model.new_password = 0
      this.model.confirm_password = 0
      this.visible_resetpwd = false
      this.errors = new Errors()
    },
    handleOk() {
      this.waiting = true
      this.$store
        .dispatch('user/resetpwd', {
          id: this.model.user_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    getClassCounts(classes) {
      return classes
    },
    isTeacherEmpty(teacher) {
      return isEmpty(teacher)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    user_type: function () {
      this.$store.commit('user/RESET_STATE')
      this.fetchData()
    },
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    disable: debounce(function (value) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('user/RESET_STATE')
    this.$store.commit('user/SET_USER_TYPE', 'staff-api')
    next()
  }
}
</script>
<style scoped>
.table-status {
  display: table;
  border-collapse: collapse;
  border: none;
}

.table-status td {
  padding: 1px;
  border-top: none !important;
  font-size: 10px;
  border-radius: 16px;
}

.allow-switch-external-mode {
  border-color: hsla(143, 79%, 39%, 0.918);
  border-width: 2px;
}
</style>
